import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { toCommaNumber } from 'common/formatters';
import { ActionList, Input, PillList } from 'common/components';
import {
  intOnly,
  maxLength,
  maxValue,
  minValue,
  required,
} from 'common/form-validators';
import { onlyNumbers, limitDigits, trim } from 'common/normalizers';
import { ACTIVITY_SIZE } from 'common/constants';
import { FertilizersChemicalsField } from './';

class DestField extends Component {
  // validations
  binSizeMin = value =>
    minValue(value, ACTIVITY_SIZE.MIN)
      ? 'Quantity can not be zero Bushels'
      : undefined;
  binSizeMax = value =>
    maxValue(value, ACTIVITY_SIZE.MAX_BIN)
      ? `Quantity can not be more than ${toCommaNumber(
          ACTIVITY_SIZE.MAX_BIN
        )} Bushels`
      : undefined;
  otherNameMax = value => maxLength(value, ACTIVITY_SIZE.MAX_TITLE);
  // normlizers
  normalizeBinSize = value => limitDigits(onlyNumbers(value), 7, 2);

  getSectionTitle = (str, destRequired = true) =>
    str && (
      <h3 className={'text--subheader'}>
        {str}
        {destRequired && <sup>*</sup>}
      </h3>
    );

  getActionBoxTitle = str => {
    const { isEdit } = this.props;
    const obj = JSON.parse(str);
    return (
      <strong>
        {obj.name}{' '}
        {obj.max && !isEdit ? (
          <span className={'text--label'}>(Max. {toCommaNumber(obj.max)})</span>
        ) : (
          ''
        )}
      </strong>
    );
  };

  getContent = (item, i, key) => {
    const { submitting } = this.props;

    return (
      <Fragment>
        {this.getActionBoxTitle(item)}
        <Input
          name={`${key}_amount[${i}]`}
          disabled={submitting}
          infoText="Bushels"
          validate={[required, intOnly, this.binSizeMin, this.binSizeMax]}
          format={toCommaNumber}
          normalize={this.normalizeBinSize}
          theme={['tight']}
          validateOnChange={true}
        />
      </Fragment>
    );
  };

  getCards = (item, i, key) => {
    const { arrayRemove } = this.props;
    return item
      ? {
          content: this.getContent(item, i, key),
          actions: [
            {
              icon: 'garbage',
              action: () => {
                arrayRemove(key, i);
                arrayRemove(`${key}_amount`, i);
              },
            },
          ],
        }
      : [];
  };

  renderFieldArray = ({ fields, meta: { submitting, error } }) => (
    <ActionList
      ref={() => fields && this.props.handleFieldsObj(fields)}
      cards={fields.map((field, idx) => ({
        content: (
          <Fragment>
            <h4 className={'text--label'}>Other *</h4>
            <Input
              name={`${field}.name`}
              disabled={submitting}
              validate={[required, this.otherNameMax]}
              theme={['tight']}
              validateOnChange={true}
              normalizeOnBlur={trim}
            />

            <Input
              name={`${field}.amount`}
              disabled={submitting}
              infoText="Bushels"
              validate={[required, intOnly, this.binSizeMin, this.binSizeMax]}
              format={toCommaNumber}
              normalize={this.normalizeBinSize}
              theme={['tight']}
              validateOnChange={true}
            />

            {error && <small className={'text--error'}>{error}</small>}
          </Fragment>
        ),

        actions: [
          {
            icon: 'garbage',
            action: () => {
              fields.remove(idx);
            },
          },
        ],
      }))}
    />
  );

  renderActionList = (option, idx) => {
    if (!option.result || !option.result.value) {
      return;
    }
    const {
      result: { value, key },
    } = option;

    // dynamic custom field for others
    if (option.result.value === 'custom') {
      return (
        <FieldArray
          key={`dest${idx}`}
          name={key}
          component={this.renderFieldArray}
        />
      );
    } else if (option.result.key === 'fertilizers') {
      return (
        <FertilizersChemicalsField
          {...this.props}
          key={`dest${idx}`}
          option={option}
          mode="fertilizer"
        />
      );

      // fertlizers field has specific data display
    } else if (option.result.key === 'chemicals') {
      return (
        <FertilizersChemicalsField
          {...this.props}
          key={`dest${idx}`}
          option={option}
          mode="chemical"
        />
      );
    } else {
      return (
        <ActionList
          key={`dest${idx}`}
          cards={value.map((item, i) => this.getCards(item, i, key))}
        />
      );
    }
  };

  render() {
    const {
      options: { dest, destTitle, destRequired },
    } = this.props;
    return dest ? (
      <fieldset className={'field'}>
        {this.getSectionTitle(destTitle, destRequired)}
        {dest.map(this.renderActionList)}
        <PillList theme={['add', 'secondary']} list={dest} />
      </fieldset>
    ) : null;
  }
}

DestField.propTypes = {
  submitting: PropTypes.bool,
  options: PropTypes.object,
  arrayRemove: PropTypes.func.isRequired,
  handleFieldsObj: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

DestField.defaultProps = {
  isEdit: false,
};

export default DestField;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/DestField.js